import React from 'react';

import { sortable } from 'react/elements/sortable';
import { SortableChatTabComponentChatRoom, ChatTabComponentChatRoom } from './ChatTabComponentChatRoom';

class ChatTabComponent extends React.PureComponent {

	constructor(props) {
		super(props);
		const { sortable } = this.props;
		this.ref = React.createRef();

		this.extraTocuhStart = null;
		this.extraTocuhEnd = null;

		const possibleComponents = {
			'sortable': SortableChatTabComponentChatRoom,
			'static': ChatTabComponentChatRoom
		};

		this.ChatTabComponentChatRoomType = possibleComponents[sortable ? 'sortable' : 'static'];

		this.touchStarted = null;
	}

	updateState() {
		this.forceUpdate();
	}

	componentDidMount() {
		if(false && this.props.isActive) {
			this.checkPositioning();
		}
	}

	componentDidUpdate(prevProps) {
		if(false && !prevProps.isActive && this.props.isActive) {
			this.checkPositioning();
		}
	}

	checkInView(container, element, partial) {

		if(!container || !element) {
			console.error('missing container or element');
			return;
		}
		//Get container properties
		let cTop = container.scrollTop;
		let cBottom = cTop + container.clientHeight;

		//Get element properties
		let eTop = element.offsetTop;
		let eBottom = eTop + element.clientHeight;

		//Check if in view
		let isTotal = (eTop >= cTop && eBottom <= cBottom);
		let isPartial = partial && (
			(eTop < cTop && eBottom > cTop) ||
			(eBottom > cBottom && eTop < cBottom)
		);

		//Return outcome
		return (isTotal || isPartial);
	}

	checkPositioning() {
		if(this.ref.current && this.ref.current.scrollIntoView) {
			if(!this.checkInView($('#chat_groups')[0], this.ref.current, true)) {
				this.ref.current.scrollIntoView({ inline: 'start' });
			}
		}
	}

	render() {
		const { name, hasUnreadMessages, hasNewMentions, items, parentName, parentImage, chatRooms, sortable, onSortItems, sortId, isActive, disableParentSort, enableParentSort, ...otherProps } = this.props;
		const ChatTabComponentChatRoomType = this.ChatTabComponentChatRoomType;

		this.extraTocuhStart = otherProps.touchStart;
		this.extraTouchEnd = otherProps.touchEnd;

		const divProps = { ...otherProps };

		delete divProps.onChatWasSelected;
		delete divProps.onTouchStart;
		delete divProps.onTouchEnd;
		delete divProps.parent;

		const sortProps = {};
		if(sortable) {
			sortProps.onSortItems = onSortItems;
			sortProps.items = chatRooms;
			sortProps.sortable = sortable;
		}

		const useParentImage = !!parentImage;
		return (
			<div
				{...divProps}
				ref={this.ref}
				onClick={this.tabClick}
				className='chat_room_group'
				title={name}
			>
				{useParentImage &&
				<div className='ladder'>
					<img src={parentImage} className='ladder_logo' />
				</div>
				}
				{!useParentImage && parentName &&
				<div className='ladder'>
					<span className='name'>{parentName}</span>
				</div>
				}
				{chatRooms.map((chatRoom, index) => (
					<ChatTabComponentChatRoomType
						{...otherProps}
						{...sortProps}
						disableParentSort={disableParentSort}
						enableParentSort={enableParentSort}
						sortId={index}
						key={chatRoom.id}
						chatRoom={chatRoom}
					/>
				))}
			</div>
		);
	}
}


const SortableChatTabComponent = sortable(ChatTabComponent);
export { SortableChatTabComponent, ChatTabComponent };